var exports = {
  "G": "sortIcon__fNM30F",
};

module.exports = exports;
